import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';

export type CityLocation = {
  city?: string;
  state?: string;
  country?: string;
  screenCount?: number;
  /** `available` = live screens; `upcoming` = coming soon / onboarding */
  status?: string;
};

export type CitiesPageResponse = {
  data?: CityLocation[];
  message?: string;
};

export async function fetchCities(
  search = '',
  page = 1,
  limit = 10,
): Promise<CitiesPageResponse> {
  const { data } = await httpClient.get(endpoints.locations.cities, {
    params: { search, page, limit, includeComingSoon: true },
  });
  return data as CitiesPageResponse;
}
